import { useState, useCallback } from 'react';
import { QueryKey } from 'react-query';

import {
  UniversalFilterItemBindingStatusValue,
  UniversalFilterItemBindingStatusModes,
  UniversalFilterItemBindingStatusFilterState,
  UniversalFilterItemBindingStatusOnFilterStateChange,
  UniversalFilterItemBindingStatusOnChange
} from '../../UniversalFilterItemBindingStatus.types';

import { useMountEffect } from '../../../../../../../common/hooks/useMountEffect';
import { useReactQueryState } from '../../../../../../../main/common/reactQuery/hooks/useReactQueryState';

import { useUniversalFilterItemBindingStatusFilterState } from '../useUniversalFilterItemBindingStatusFilterState';

import {
  UniversalFilterTemplateModeOption,
  UniversalFilterTemplateOnModeChange
} from '../../../../helpers/UniversalFilterTemplate';

import { filtersKeys } from '../../../../../../../locales/keys';
import { GroupedItemBindingStatuses } from '../../../../../../../main/groupedItems/groupedItemsTypes';

const defaultMode = UniversalFilterItemBindingStatusModes.CONTAINS_ALL_OF;

const modeOptions: UniversalFilterTemplateModeOption<UniversalFilterItemBindingStatusModes>[] =
  [
    // {
    //   value: UniversalFilterItemBindingStatusModes.CONTAINS_ANY_OF,
    //   i18nText: filtersKeys.modes.containsAnyOf
    // }
    {
      value: UniversalFilterItemBindingStatusModes.CONTAINS_ALL_OF,
      i18nText: filtersKeys.modes.containsAllOf
    }
    // {
    //   value: UniversalFilterItemBindingStatusModes.CONTAINS_ONLY,
    //   i18nText: filtersKeys.modes.containsOnly
    // },
    // {
    //   value: UniversalFilterItemBindingStatusModes.CONTAINS_NONE_OF,
    //   i18nText: filtersKeys.modes.containsNoneOf
    // },
    // {
    //   value: UniversalFilterItemBindingStatusModes.DOES_NOT_CONTAIN_ANY_OF,
    //   i18nText: filtersKeys.modes.doesNotContainAnyOf
    // }
    // {
    //   value: UniversalFilterItemBindingStatusModes.IS_EMPTY,
    //   i18nText: filtersKeys.modes.isEmpty
    // },
    // {
    //   value: UniversalFilterItemBindingStatusModes.IS_NOT_EMPTY,
    //   i18nText: filtersKeys.modes.isNotEmpty
    // }
  ];

interface UniversalFilterItemBindingStatusOptions {
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterItemBindingStatusValue;
  onChange: UniversalFilterItemBindingStatusOnChange;
}

function useUniversalFilterItemBindingStatus({
  filterStateCacheKey,
  filterValue,
  onChange
}: UniversalFilterItemBindingStatusOptions) {
  const { value: savedState, setValue: saveState } =
    useReactQueryState<UniversalFilterItemBindingStatusFilterState>(
      filterStateCacheKey
    );

  const { handleApplyFilterState, handleParseFilterValue } =
    useUniversalFilterItemBindingStatusFilterState({
      onChange
    });

  const [filterState, setFilterState] =
    useState<UniversalFilterItemBindingStatusFilterState>(
      savedState ||
        handleParseFilterValue(filterValue) || {
          mode: defaultMode,
          bindingStatus: undefined
        }
    );

  useMountEffect(() => {
    handleApplyFilterState(filterState);
  });

  const handleFilterStateChange =
    useCallback<UniversalFilterItemBindingStatusOnFilterStateChange>(
      (state) => {
        setFilterState(state);
        handleApplyFilterState(state);
        saveState(state);
      },
      [handleApplyFilterState, saveState]
    );

  const handleModeChange = useCallback<
    UniversalFilterTemplateOnModeChange<UniversalFilterItemBindingStatusModes>
  >(
    (mode) => {
      handleFilterStateChange({
        mode,
        bindingStatus: filterState.bindingStatus
      });
    },
    [filterState, handleFilterStateChange]
  );

  const handleBindingStatusesChange = useCallback<
    (bindingStatus: GroupedItemBindingStatuses[]) => void
  >(
    (bindingStatus) => {
      handleFilterStateChange({
        mode: filterState.mode,
        bindingStatus: bindingStatus
      });
    },
    [filterState, handleFilterStateChange]
  );

  return {
    modeOptions,
    filterState,
    handleModeChange,
    handleBindingStatusesChange
  };
}

export default useUniversalFilterItemBindingStatus;
